import { fromJS } from 'immutable';
//Action types
const FETCH_TEAMS_REQUEST = 'FETCH_TEAMS_REQUEST';
const FETCH_TEAMS_SUCCESS = 'FETCH_TEAMS_SUCCESS';
const FETCH_TEAMS_ERROR = 'FETCH_TEAMS_ERROR';
//const GET_TEAM_ID_BY_NAME = 'GET_TEAM_ID_BY_NAME';

//Action creators 
export const fetchTeamsRequest = () => ({ type: FETCH_TEAMS_REQUEST });
export const fetchTeamsSuccess = (teams) => ({ type: FETCH_TEAMS_SUCCESS, teams });
//const fetchTeamsError = (error) => ({ type: FETCH_TEAMS_ERROR, error });
//export const getTeamIdByName = () => ({ type: GET_TEAM_ID_BY_NAME, teamName });
// epic
export const fetchTeamsEpic = (action$, store, {getTeams}) =>
    action$.ofType(FETCH_TEAMS_REQUEST)
        .mergeMap(action =>
            getTeams()
                .map(response => {
                  console.log('FETCH_TEAMS_REQUEST response', response);
                    return fetchTeamsSuccess(response)
                })
        );

//initial state for this reducer
const initialState = fromJS({
    teams: [],
    isLoading: false,
    //error: '' 
});

//Reducer
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_TEAMS_REQUEST:
            return state.set('isLoading', true);
        case FETCH_TEAMS_SUCCESS:
            return state.set('isLoading', false).set('teams', fromJS(action.teams));
        case FETCH_TEAMS_ERROR:
            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/modules/teamsDuck.js